import React from 'react';
import Switch from '@tencent/dui/lib/components/Switch';
import { IAnonymousViewService } from '@src/slide/application/service/anonymous-view-service';
import { tdwWithVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';

interface IProps {
    anonymousViewService: IAnonymousViewService;
    handleSwitch(): void;
}

interface ISwitchState {
    isChecked: boolean;
}

export class SwitchAnonymousView extends React.Component<IProps, ISwitchState> {
    public constructor(props: IProps) {
        super(props);

        this.state = {
            isChecked: this.props.anonymousViewService.anonymousStatus,
        };
    }

    public componentDidMount() {
        this.setState({
            isChecked: this.props.anonymousViewService.anonymousStatus,
        });
        this.props.anonymousViewService.events.on('ANONYMOUS_CHANGE', () => {
            if (this.props.anonymousViewService.anonymousStatus !== this.state.isChecked) {
                this.setState({
                    isChecked: this.props.anonymousViewService.anonymousStatus,
                });
            }
        });
        tdwWithVip({
            module: this.props.anonymousViewService.anonymousStatus ? 'close' : 'entrance',
            opername: 'doc_vip_invisible',
            action: 'show',
            ver9: 'pc_titlebar',
        });
    }

    public render() {
        const pcSwitchStyle: React.CSSProperties = {
            position: 'relative',
            top: -3,
            width: 22,
            height: 10,
        };

        return (
            <Switch
                style={pcSwitchStyle}
                size="small"
                checked={this.state.isChecked}
                onChange={this.props.handleSwitch}
            />
        );
    }
}
